import { useNavigate, useParams } from "react-router-dom";
import { PageContainer } from "../../../../components/layout";
import { Box, Paper, Skeleton, Typography } from "@mui/material";
import { ApiQueries, RecordModeEnum, RecordView, DaymapSkeleton, ExcursionDetails } from "daymap-react";
import PageHeader from '../../../../containers/pageheader/pageheader';

export function ExcursionView() {
    const { studentId, eventId } = useParams();
    const navigate = useNavigate();

    const { isPending, data, error } = new ApiQueries.calendars.CalendarEventDetails(Number(eventId) ?? 0).ToQuery();
    const { data: record, isPending: recordPending } = new ApiQueries.forms.RecordFromEvent({ eventId: Number(eventId), studentId: Number(studentId)}).ToQuery();



    return <>
        <PageHeader title={data?.Title} onBackButtonClick={() => navigate(-1)}></PageHeader>
        <PageContainer sx={{ display: "flex", flexDirection: "column", gap: 2}}>

            {error && <NoAccess /> }
            {isPending ? <Skeleton variant="rounded" height={75} /> : data && <ExcursionDetails {...data!} />}
            {recordPending ? <DaymapSkeleton type="listitems" length={5} /> : record && <Paper>
                <Box p={2}>
                    <RecordView studentId={Number(studentId)} formId={record.Record.FormId} rowId={record.Record.RowId} editMode={RecordModeEnum.Read} />
                </Box>
            </Paper>}
        </PageContainer>
    </>
}

const NoAccess = () => {
    return (<>
        <Typography align="center">You do not have permission to this event or it does not exist</Typography>
    </>)
}